import { AxiosError, AxiosResponse } from 'axios'

export enum CurrencyCode {
  GBP = 'GBP',
  EUR = 'EUR',
}

export enum ErrorCode {
  OK = 200,
  Created = 210,
  BadRequest = 400,
  Unauthorized = 401,
  Forbidden = 403,
  NotFound = 404,
  ServerError = 500,
}

export type DebugRequest = {
  url: string
  baseUrl: string
  method: string
  data: string
  params: string
}
export type DebugResponse = {
  url: string
  status: number
  message: string
  data: string
}
export type DebugError = {
  url: string
  error: AxiosError
  response: AxiosResponse | undefined
}
